import API from '../api';

export default class AchievementService {
  constructor() {
    this.API = new API();
  }

  getAchievements = (accountId) => this.API.get(`/achievementEvent/events/${accountId}`);
}
